import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import { useAuth } from '../../contexts/AuthContext';
import { canImpersonate, canManageRoles } from '../../constants/adminRoles';

export default function AdminHomePage() {
  const { t } = useLanguage();
  const { adminRole } = useAuth();
  const role = adminRole || 'super_admin';
  return (
    <div className="mx-auto max-w-4xl space-y-6">
      <div>
        <h1 className="text-xl font-semibold text-slate-900">{t('admin.home.title')}</h1>
        <p className="mt-1 text-sm text-slate-600">{t('admin.home.subtitle')}</p>
      </div>
      <section className="rounded-xl border border-dashed border-slate-300 bg-white p-4">
        <h2 className="text-sm font-semibold text-slate-800">{t('admin.home.actionCenterTitle')}</h2>
        <p className="mt-1 text-sm text-slate-500">{t('admin.home.actionCenterSoon')}</p>
      </section>
      <div className="grid gap-3 sm:grid-cols-2">
        <Link to="/admin/feedback" className="rounded-xl border border-slate-200 bg-white p-4 text-sm font-medium hover:border-indigo-300">
          {t('admin.nav.feedback')}
        </Link>
        <Link to="/admin/approvals" className="rounded-xl border border-slate-200 bg-white p-4 text-sm font-medium hover:border-indigo-300">
          {t('admin.nav.approvals')}
        </Link>
        {canImpersonate(role) ? (
          <Link to="/admin/impersonate" className="rounded-xl border border-slate-200 bg-white p-4 text-sm font-medium hover:border-indigo-300">
            {t('admin.nav.impersonate')}
          </Link>
        ) : null}
        {canManageRoles(role) ? (
          <Link to="/admin/settings" className="rounded-xl border border-slate-200 bg-white p-4 text-sm font-medium hover:border-indigo-300">
            {t('admin.nav.settings')}
          </Link>
        ) : null}
      </div>
    </div>
  );
}
